const routes = [
  {
    path: '/user',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('pages/IndexPage.vue') },
      {
        path: 'profile',
        component: () => import('pages/user/Profile.vue'),
      },
    ],
  },
  {
    path: '/data',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('pages/IndexPage.vue') },
      {
        path: 'test8search',
        component: () => import('pages/data/EightTestSearch.vue'),
      },
      {
        path: 'test8result/:result_id',
        component: () => import('pages/data/EightTestResultView.vue'),
      },
      {
        path: 'gsva_result_list/:dataname/:search_order',
        component: () => import('pages/data/GSVAResultList.vue'),
      },
      {
        path: 'requestlist',
        component: () => import('pages/data/RequestList.vue'),
      },
      {
        path: 'analysisqueue',
        component: () => import('pages/data/AnalysisQueue.vue'),
      },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/BlankLayout.vue'),
    children: [
      { path: '', component: () => import('pages/SignIn.vue') },
      { path: 'signin', component: () => import('pages/SignIn.vue') },
      { path: 'signup', component: () => import('pages/SignUp.vue') },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
